import {
	FETCH_ADMIN_ROIS,
	FETCH_ADMIN_ROIS_SUCCESS,
	FETCH_ADMIN_ROIS_ERROR,
	ADMIN_LINK_ROI,
	ADMIN_LINK_ROI_SUCCESS,
	ADMIN_LINK_ROI_ERROR,
	ADMIN_REVOKE_ROI,
	ADMIN_REVOKE_ROI_SUCCESS,
	ADMIN_REVOKE_ROI_ERROR,
	APPROVE_ROI_MATCH,
	APPROVE_ROI_MATCH_SUCCESS,
	APPROVE_ROI_MATCH_ERROR,
	REJECT_ROI_MATCHES,
	REJECT_ROI_MATCHES_SUCCESS,
	REJECT_ROI_MATCHES_ERROR,
} from './constants';

export const fetchAdminRois = (params) => ({
	type: FETCH_ADMIN_ROIS,
	params,
});

export const fetchAdminRoisSuccess = (data) => ({
	type: FETCH_ADMIN_ROIS_SUCCESS,
	data,
});

export const fetchAdminRoisError = (err) => ({
	type: FETCH_ADMIN_ROIS_ERROR,
	err,
});

export const adminLinkRoi = (data) => ({
	type: ADMIN_LINK_ROI,
	data,
});

export const adminLinkRoiSuccess = (data) => ({
	type: ADMIN_LINK_ROI_SUCCESS,
	data,
});

export const adminLinkRoiError = (err) => ({
	type: ADMIN_LINK_ROI_ERROR,
	err,
});

export const adminRevokeRoi = (data) => ({
	type: ADMIN_REVOKE_ROI,
	data,
});

export const adminRevokeRoiSuccess = (data) => ({
	type: ADMIN_REVOKE_ROI_SUCCESS,
	data,
});

export const adminRevokeRoiError = (err) => ({
	type: ADMIN_REVOKE_ROI_ERROR,
	err,
});

export const approveRoiMatch = (roiId, candidateId) => ({
	type: APPROVE_ROI_MATCH,
	roiId,
	candidateId,
});

export const approveRoiMatchSuccess = (data) => ({
	type: APPROVE_ROI_MATCH_SUCCESS,
	data,
});

export const approveRoiMatchError = (err) => ({
	type: APPROVE_ROI_MATCH_ERROR,
	err,
});

export const rejectRoiMatches = (roiId) => ({
	type: REJECT_ROI_MATCHES,
	roiId,
});

export const rejectRoiMatchesSuccess = (data) => ({
	type: REJECT_ROI_MATCHES_SUCCESS,
	data,
});

export const rejectRoiMatchesError = (err) => ({
	type: REJECT_ROI_MATCHES_ERROR,
	err,
});
